import React, { Component, Fragment } from "react";
import joint from "rappid";
import App from "components/DiagramDesigner";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import { locationPrefix } from "common/general";
import {
	Spin,
	Tabs,
	Button,
	Card,
	message,
	Radio,
	Form,
	Input,
	Divider
} from "antd";
import { inject, observer } from "mobx-react";
import StrategyTab from "./components/StrategyTab";
import GeneralTab from "./components/GeneralTab";
import ContentTab from "./components/ContentTab";
import AccountsTab from "./components/AccountsTab";
import ScheduleTab from "./components/ScheduleTab";
import SitesTab from "./components/SitesTab-Tiers";
import IndexerTab from "./components/IndexerTab";
import EmailsTab from "./components/EmailsTab";
import ConfirmationTab from "./components/ConfirmationTab";
import { delay } from "services/api";

import co from "co";
const FormItem = Form.Item;
// import FileSaver from "file-saver";

const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 3 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 21 }
	}
};

@inject("rootStore")
@observer
class MainTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "Strategy"
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	componentDidUpdate = (prevProps, prevState, snapshot) => {
		const {
			rootStore: { xwizardStore }
		} = this.props;

		xwizardStore.setActiveTabKey(this.state.activeKey);
	};

	render() {
		const {
			rootStore: { xwizardStore, routerStore }
		} = this.props;

		const ui = xwizardStore.ui;

		return (
			<Tabs
				animated={false}
				activeKey={this.state.activeKey}
				onChange={this.handleTabChange}
				tabBarExtraContent={
					<Fragment>
						{routerStore.routerState.routeName != "newcampaign" &&
						routerStore.routerState.routeName !=
							"duplicatecampaign" ? (
							<Button
								type="primary"
								loading={ui.savingWizard}
								onClick={this.props.saveWizard}
							>
								Save Wizard
							</Button>
						) : (
							""
						)}
						{'  '}
						<Button
							type="primary"
							// onClick={this.props.createCampaign}
							onClick={() => {
								//If this is new campaign or duplicate campaign, we have the option to create a new wizard or not
								if (
									routerStore.routerState.routeName ==
										"newcampaign" ||
									routerStore.routerState.routeName ==
										"duplicatecampaign"
								) {
									this.props.createCampaign();
								} else {
									//If this is create new wizard or open an existing wizard, we always save the wizard when creating campaign
									this.props.createCampaign(true);
								}
							}}
							loading={ui.creatingCampaign == true}
						>
							Create Campaign
						</Button>
					</Fragment>
				}
			>
				{this.props.children}
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class XWizardPage extends Component {
	// componentDidMount() {
	// 	const {
	// 		rootStore: { xwizardStore }
	// 	} = this.props;
	// 	const { ui } = xwizardStore;

	// 	when(
	// 		() => {
	// 			const appDiv = document.getElementById("app");
	// 			return appDiv != null;
	// 		},
	// 		() => {
	// 			console.log("Rendering");
	// 			joint.setTheme("modern");
	// 			let app = (this.app = new App.MainView({ el: "#app" }));
	// 			let diagram = {
	// 				cells: [
	// 					{
	// 						type: "rankerx.MoneySite",
	// 						position: { x: 310, y: 100 },
	// 						size: { width: 100, height: 54 },
	// 						angle: 0,
	// 						id: "90ad0d12-b105-4a72-bc1d-360fe5f5a973",
	// 						z: 1
	// 					},
	// 					{
	// 						type: "rankerx.SocialNetwork",
	// 						position: { x: 210, y: 279 },
	// 						size: { width: 90, height: 54 },
	// 						angle: 0,
	// 						id: "97357d8d-615d-4069-b022-08841cdee0e8",
	// 						z: 2
	// 					},
	// 					{
	// 						type: "app.Link",
	// 						router: { name: "normal" },
	// 						connector: { name: "rounded" },
	// 						labels: [],
	// 						source: { id: "90ad0d12-b105-4a72-bc1d-360fe5f5a973" },
	// 						target: { id: "97357d8d-615d-4069-b022-08841cdee0e8" },
	// 						id: "ed0addb6-4e8c-4017-ba28-c24a7c5e9c35",
	// 						z: 3
	// 					},
	// 					{
	// 						type: "rankerx.WebProfile",
	// 						position: { x: 410, y: 279 },
	// 						size: { width: 90, height: 54 },
	// 						angle: 0,
	// 						id: "b1698117-c6b5-490f-ada2-b003f1dd08e8",
	// 						z: 4
	// 					},
	// 					{
	// 						type: "app.Link",
	// 						router: { name: "normal" },
	// 						connector: { name: "rounded" },
	// 						labels: [],
	// 						source: { id: "90ad0d12-b105-4a72-bc1d-360fe5f5a973" },
	// 						target: { id: "b1698117-c6b5-490f-ada2-b003f1dd08e8" },
	// 						id: "a6cf419e-8792-4ecc-81f4-c5c909bfb026",
	// 						z: 5
	// 					},
	// 					{
	// 						type: "rankerx.WebProfile",
	// 						position: { x: 80, y: 410 },
	// 						size: { width: 90, height: 54 },
	// 						angle: 0,
	// 						id: "fef1a01f-d370-4586-9181-a7386b02b7db",
	// 						z: 6
	// 					},
	// 					{
	// 						type: "app.Link",
	// 						router: { name: "normal" },
	// 						connector: { name: "rounded" },
	// 						labels: [],
	// 						source: { id: "97357d8d-615d-4069-b022-08841cdee0e8" },
	// 						target: { id: "fef1a01f-d370-4586-9181-a7386b02b7db" },
	// 						id: "8724caa8-c950-40d6-8c64-8d64f9f3bc02",
	// 						z: 7
	// 					},
	// 					{
	// 						type: "rankerx.Bookmarking",
	// 						position: { x: 410, y: 388 },
	// 						size: { width: 90, height: 54 },
	// 						angle: 0,
	// 						id: "9ef4022f-a46b-4be7-aafd-aaccaa52ecc9",
	// 						z: 8
	// 					},
	// 					{
	// 						type: "app.Link",
	// 						router: { name: "normal" },
	// 						connector: { name: "rounded" },
	// 						labels: [],
	// 						source: { id: "b1698117-c6b5-490f-ada2-b003f1dd08e8" },
	// 						target: { id: "9ef4022f-a46b-4be7-aafd-aaccaa52ecc9" },
	// 						id: "1b844450-8aa0-4718-bf6c-a4b8a7bfe465",
	// 						z: 9
	// 					},
	// 					{
	// 						type: "rankerx.WebProfile",
	// 						position: { x: 220, y: 410 },
	// 						size: { width: 90, height: 54 },
	// 						angle: 0,
	// 						id: "e235bd1d-bec9-4ce7-99e8-88dd35292604",
	// 						z: 10
	// 					},
	// 					{
	// 						type: "app.Link",
	// 						router: { name: "normal" },
	// 						connector: { name: "rounded" },
	// 						labels: [],
	// 						source: { id: "97357d8d-615d-4069-b022-08841cdee0e8" },
	// 						target: { id: "e235bd1d-bec9-4ce7-99e8-88dd35292604" },
	// 						id: "0d44d4ef-ffeb-4454-a6c2-9d79869f8418",
	// 						z: 11
	// 					}
	// 				]
	// 			};
	// 			this.app.loadDiagram(diagram);
	// 		}
	// 	);
	// 	// let themePicker = new App.ThemePicker({ mainView: app });
	// 	// themePicker.render().$el.appendTo(document.body);
	// 	// let moneySite = new joint.shapes.rankerx.Project({
	// 	// 	modules: [
	// 	// 		{
	// 	// 			id: "SocialNetwork",
	// 	// 			name: "Web 2.0 Blogs",
	// 	// 			backgroundColor: "#3b5998",
	// 	// 			textColor: "#f6f6f6",
	// 	// 			checked: false
	// 	// 		},
	// 	// 		{
	// 	// 			id: "WebProfile",
	// 	// 			name: "Web 2.0 Profile",
	// 	// 			backgroundColor: "#feb663",
	// 	// 			textColor: "#222138",
	// 	// 			checked: false
	// 	// 		},
	// 	// 		{
	// 	// 			id: "Bookmarking",
	// 	// 			name: "Boomarking",
	// 	// 			backgroundColor: "#b75d32",
	// 	// 			textColor: "#f6f6f6",
	// 	// 			checked: false
	// 	// 		},
	// 	// 		{
	// 	// 			id: "Wiki",
	// 	// 			name: "Wiki",
	// 	// 			backgroundColor: "#dcd7d7",
	// 	// 			textColor: "#222138",
	// 	// 			checked: false
	// 	// 		},
	// 	// 		{
	// 	// 			id: "ArticleDirectory",
	// 	// 			name: "Article Directory",
	// 	// 			backgroundColor: "#eb4924",
	// 	// 			textColor: "#f6f6f6",
	// 	// 			checked: false
	// 	// 		},
	// 	// 		{
	// 	// 			id: "PDF",
	// 	// 			name: "PDF",
	// 	// 			backgroundColor: "#7c68fc",
	// 	// 			textColor: "#f6f6f6",
	// 	// 			checked: false
	// 	// 		},
	// 	// 		{
	// 	// 			id: "ForumProfile",
	// 	// 			name: "Forum Profile",
	// 	// 			backgroundColor: "transparent",
	// 	// 			textColor: "#222138",
	// 	// 			checked: false
	// 	// 		},
	// 	// 		{
	// 	// 			id: "PressRelease",
	// 	// 			name: "Press Release",
	// 	// 			backgroundColor: "#31d0c6",
	// 	// 			textColor: "#222138",
	// 	// 			checked: false
	// 	// 		}
	// 	// 	]
	// 	// });
	// 	// let moneySite = new joint.shapes.rankerx.MoneySite();
	// 	// moneySite.position(300, 300);
	// 	// moneySite.resize(100, 54);
	// 	// app.graph.addCells(moneySite);
	// 	// app.graph.fromJSON(JSON.parse(App.config.sampleGraphs.emergencyProcedure));
	// }

	saveWizard = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;

		xwizardStore.saveWizard();
	};

	createCampaign = wouldSaveWizard => {
		const {
			rootStore: { xwizardStore, routerStore }
		} = this.props;

		co(
			function*() {
				let result = yield this.sitesTab.validateForm();
				if (result != null) {
					this.mainTabs.setActiveKey("Sites");
					message.error(
						"Fix the problems below before saving the wizard"
					);
					return;
				}

				result = yield this.generalTab.validateForm();
				if (result != null) {
					this.mainTabs.setActiveKey("General");					
					message.error(
						"Fix the problems below before saving the wizard"
					);
					return;
				}

				result = yield this.contentTab.validateForm();
				if (result != null) {
					this.mainTabs.setActiveKey("Content");
					message.error(
						"Fix the problems below before saving the wizard"
					);
					return;
				}

				result = yield this.accountsTab.validateForm();
				if (result != null) {
					this.mainTabs.setActiveKey("Accounts");
					yield this.accountsTab.validateForm();
					message.error(
						"Fix the problems below before saving the wizard"
					);
					return;
				}

				result = yield this.emailsTab.validateForm();
				if (result != null) {
					this.mainTabs.setActiveKey("Emails");
					message.error(
						"Fix the problems below before saving the wizard"
					);
					return;
				}

				result = yield this.indexerTab.validateForm();
				if (result != null) {
					this.mainTabs.setActiveKey("Indexer");
					message.error(
						"Fix the problems below before saving the wizard"
					);
					return;
				}

				result = yield this.scheduleTab.validateForm();
				if (result != null) {
					this.mainTabs.setActiveKey("Schedule");
					message.error(
						"Fixed the problems below before saving the wizard"
					);
					return;
				}

				result = yield this.confirmationTab.validateForm();
				if (result != null) {
					this.mainTabs.setActiveKey("Confirm");
					message.error(
						"Fixed the problems below before saving the wizard"
					);
					return;
				}

				if (
					routerStore.routerState.routeName == "newcampaign" ||
					routerStore.routerState.routeName == "duplicatecampaign"
				) {
					xwizardStore.createCampaign();
				} else if (wouldSaveWizard) {
					xwizardStore.createCampaign(true);
				}
			}.bind(this)
		);
	};

	render() {	
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const { ui } = xwizardStore;

		let breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			},
			{
				title: "Wizards",
				href: locationPrefix + "/xwizards"
			},
			{
				title: "Wizard" + (xwizardStore.wizard.name ? ": " + xwizardStore.wizard.name : "")
			}
		];

		if (ui.loading) {
			return <div />;
		}

		let strategyTab = <StrategyTab />;

		let generalTab = (
			<GeneralTab
				ref={tab => {
					if (tab != null) {
						this.generalTab = tab.wrappedInstance;
					}
				}}
			/>
		);
		let contentTab = (
			<ContentTab
				ref={tab => {
					if (tab != null) {
						this.contentTab = tab.wrappedInstance;
					}
				}}
			/>
		);

		let emailsTab = (
			<EmailsTab
				ref={tab => {
					if (tab != null) {
						this.emailsTab = tab.wrappedInstance;
					}
				}}
			/>
		);

		let accountsTab = (
			<AccountsTab
				ref={tab => {
					if (tab != null) {
						this.accountsTab = tab.wrappedInstance;
					}
				}}
			/>
		);

		let sitesTab = (
			<SitesTab
				ref={tab => {
					if (tab != null) {
						this.sitesTab = tab.wrappedInstance;
					}
				}}
			/>
		);

		let indexerTab = (
			<IndexerTab
				ref={tab => {
					if (tab != null) {
						this.indexerTab = tab.wrappedInstance;
					}
				}}
			/>
		);

		let scheduleTab = (
			<ScheduleTab
				ref={tab => {
					if (tab != null) {
						this.scheduleTab = tab.wrappedInstance;
					}
				}}
			/>
		);

		let confirmationTab = (
			<ConfirmationTab
				ref={tab => {
					if (tab != null) {
						this.confirmationTab = tab.wrappedInstance;
					}
				}}
			/>
		);

		let spinning = ui.creatingCampaign == true;

		return (
			<Fragment>
				<PageHeaderLayout breadcrumbList={breadcrumbList}>
					<Card>
						<Spin spinning={spinning}>
							<MainTabs
								ref={mainTabs => {
									if (mainTabs != null) {
										this.mainTabs =
											mainTabs.wrappedInstance;
									}
								}}
								createCampaign={this.createCampaign}
								saveWizard={this.saveWizard}
							>
								<TabPane
									tab="Strategy"
									key="Strategy"
									forceRender={true}
								>
									{strategyTab}
								</TabPane>
								<TabPane
									tab="Sites"
									key="Sites"
									forceRender={true}
								>
									{sitesTab}
								</TabPane>
								<TabPane
									tab="Links & Keywords"
									key="General"
									forceRender={true}
								>
									{generalTab}
								</TabPane>
								<TabPane
									tab="Content"
									key="Content"
									forceRender={true}
								>
									{contentTab}
								</TabPane>
								<TabPane
									tab="Accounts"
									key="Accounts"
									forceRender={true}
								>
									{accountsTab}
								</TabPane>
								<TabPane
									tab="Emails"
									key="Emails"
									forceRender={true}
								>
									{emailsTab}
								</TabPane>
								<TabPane
									tab="Indexer"
									key="Indexer"
									forceRender={true}
								>
									{indexerTab}
								</TabPane>
								<TabPane
									tab="Schedule"
									key="Schedule"
									forceRender={true}
								>
									{scheduleTab}
								</TabPane>
								<TabPane
									tab="Confirm"
									key="Confirm"
									forceRender={true}
								>
									{confirmationTab}
								</TabPane>
							</MainTabs>
						</Spin>
					</Card>
				</PageHeaderLayout>
			</Fragment>
		);
	}
}

export default XWizardPage;
